import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';

import {
  TableBuilderFactory,
  TableComponent,
  TableConfig,
  TableDataPayload,
  TableLazyLoad,
} from '@web/shared/ui';
import {
  PublicSubscriptionDataSourceService,
  PublicSubscriptionOrderCollectionFilter,
  PublicSubscriptionOrderCollectionItem,
  SubscriptionNumber,
} from '@web/shared/module/shop';
import { Observable } from 'rxjs';
import { PublicSubscriptionOrderListCustomCellTemplateComponent } from '../../components/public-subscription-order-list-custom-cell-template/public-subscription-order-list-custom-cell-template.component';

@Component({
  selector: 'app-public-subscription-order-list',
  imports: [
    TableComponent,
    PublicSubscriptionOrderListCustomCellTemplateComponent,
  ],
  templateUrl: './public-subscription-order-list.component.html',
  styleUrl: './public-subscription-order-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSubscriptionOrderListComponent implements OnInit {
  public readonly number = input.required<SubscriptionNumber>();

  protected config!: TableConfig<
    PublicSubscriptionOrderCollectionItem,
    PublicSubscriptionOrderCollectionFilter
  >;

  /* prettier-ignore */
  private readonly builder = inject(TableBuilderFactory<PublicSubscriptionOrderCollectionItem, PublicSubscriptionOrderCollectionFilter>).create();
  /* prettier-ignore */
  private readonly subscriptionDataSource = inject(PublicSubscriptionDataSourceService);

  public ngOnInit(): void {
    this.buildTable();
  }

  /* prettier-ignore */
  private buildTable(): void {
    this.config = this.builder
      .dataKey('id')
      .topScrollEnabled(false)
      .filtering(false)
      .columns((builder) => [
        builder //
          .initOrdinal()
          .build(),

        builder //
          .initCustom('number')
          .label('Numer')
          .width('10rem')
          .sortKey('number')
          .build(),

        builder //
          .initCurrency('totalPrice')
          .label('Kwota')
          .width('10rem')
          .sortKey('totalPrice')
          .build(),

        builder //
          .initCustom('status')
          .width('12rem')
          .label('Status')
          .sortKey('status')
          .build(),

        builder //
          .initDate('createdAt')
          .width('12rem')
          .label('Data zamówienia')
          .sortKey('createdAt')
          .build(),
      ])
      .dataSource({
        fetch: (
          lazyLoad: TableLazyLoad<PublicSubscriptionOrderCollectionFilter>,
        ): Observable<TableDataPayload<PublicSubscriptionOrderCollectionItem>> =>
          this.subscriptionDataSource.fetchSubscriptionOrderCollection({
            number: this.number(),
            lazyLoad,
          }),
      })
      .build();
  }
}
